import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Paper, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import * as React from 'react';
import { Calendar, Views, dayjsLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import { messagesCalendar } from '../../control_estudios/horarios/components/VistaHorarios';
import { allEventosAction, setActivoEventosAction } from '../EventosAction';
import { PARAMS_EVENTOS, SLOTINFO_EVENTOS } from '../EventosReducer';
import DetallesEventosComponent from './DetallesEventos';

const localizer = dayjsLocalizer(dayjs);

const CalendarioEventosComponent = ({
  viewCalendar = Views.MONTH,
  isDetalles = false,
  setOpenModalForm = () => {},
}) => {
  const dispatch = Redux.useDispatch();

  const eventosStore = Redux.useSelector((state) => state.eventos);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const [openModalDetalles, setOpenModalDetalles] = React.useState(false);

  const [eventos, setEventos] = React.useState([]);
  const [view, setView] = React.useState(viewCalendar);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...eventosStore.params,
        idEntidad: entidadesStore.activo?.id,
      };
      dispatch({
        type: PARAMS_EVENTOS,
        payload,
      });
      if (eventosStore.all && eventosStore.all.length === 0) {
        await allEventosAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let events = [];
    eventosStore.all.forEach((el) => {
      events.push({
        id: el.id,
        evento: el,
        color: el.color,
        start: dayjs(el.inicio).toDate(),
        end: dayjs(el.fin).toDate(),
        title: el.nombre,
      });
    });
    setEventos(events);
  }, [eventosStore.all]);

  const event = (eventProps) => {
    const { event } = eventProps;
    const isMonth = view === Views.MONTH;
    // Personaliza el estilo de cada evento
    const eventStyle = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    };

    const styleTextCalendar = {
      fontSize: isMonth ? '10pt' : '12pt',
      fontWeight: 'bold',
    };

    return (
      <Box sx={eventStyle}>
        {event.evento ? (
          <>
            <Stack direction="row" spacing={1} alignItems="center">
              {isMonth &&
                (event.evento.public ? (
                  <PeopleIcon fontSize="inherit" sx={{ color: 'white' }} />
                ) : (
                  <PersonIcon fontSize="inherit" sx={{ color: 'white' }} />
                ))}
              <Typography textAlign="center" sx={styleTextCalendar}>
                {event.title}
              </Typography>
            </Stack>
            {!isMonth && (
              <Typography
                sx={{
                  ...styleTextCalendar,
                  fontSize: '7pt',
                }}
              >
                {event.evento.desc}
              </Typography>
            )}
            {/* <Typography sx={{ fontSize: '9pt' }}>
              {event.evento.seccion.nivelAcademico.nivelAcademico.abrev}
              {' - '}
              {event.evento.seccion.nombre}
            </Typography>
            <Typography sx={{ ...styleTextCalendar, fontSize: '8pt' }}>
              {event.evento.docente.usuario.perfil.pnombre}{' '}
              {event.evento.docente.usuario.perfil.papellido}
            </Typography>

            {!eventosStore.settings.isEstatus && event.evento.aula ? (
              <Typography
                sx={{
                  ...styleTextCalendar,
                  fontSize: '8pt',
                }}
              >
                Aula: {event.evento.aula?.nombre}
              </Typography>
            ) : null}
            {!eventosStore.settings.isEstatus ? null : (
              <Chip
                label={event.evento.estatus.nombre}
                size="small"
                sx={{
                  fontSize: '7pt',
                }}
                color={event.evento.estatus.id === 1 ? 'success' : 'error'}
              />
            )} */}

            {!isMonth && (
              <Stack direction="row" spacing={1} alignItems="center">
                {event.evento.public ? (
                  <PeopleIcon fontSize="inherit" sx={{ color: 'white' }} />
                ) : (
                  <PersonIcon fontSize="inherit" sx={{ color: 'white' }} />
                )}
                <Typography
                  variant="caption"
                  color="white"
                  sx={{ fontWeight: 'bold' }}
                >
                  {event.evento.public ? 'Público' : 'Personal'}
                </Typography>
              </Stack>
            )}
          </>
        ) : (
          <>
            <Typography
              sx={{ textAlign: 'start', fontSize: '9pt', width: '100%' }}
            >
              {event.title}
            </Typography>
          </>
        )}
      </Box>
    );
  };

  function handleMonthChange(date) {
    console.log('El mes fue cambiado a: ', date);
  }

  return (
    <Paper elevation={4} sx={{ p: 2 }}>
      <Calendar
        messages={messagesCalendar}
        localizer={localizer}
        defaultDate={dayjs()}
        style={{ height: '100vh' }}
        events={eventos}
        views={['month', 'week']}
        view={view}
        onView={(newView) => setView(newView)}
        selectable
        popup
        onSelectSlot={(slotInfo) => {
          setActivoEventosAction(dispatch, null);
          dispatch({
            type: SLOTINFO_EVENTOS,
            payload: slotInfo,
          });
          setOpenModalForm(true);
        }}
        components={{ event }}
        onRangeChange={handleMonthChange}
        eventPropGetter={(event) => {
          let style = {
            backgroundColor: event.color ?? '#2b2b2b',
            color: 'white',
            borderRadius: '7px',
            border:
              event.id === eventosStore.activo?.id
                ? 'solid 3px blue'
                : event.horario?.estatus.id === 2
                ? 'solid 1px red'
                : 'solid 1px white',
            fontSize: '10pt',
          };

          if (event.isMine) {
            style.backgroundColor = 'lightgreen';
          }

          return {
            className: '',
            style,
          };
        }}
        onSelectEvent={(event, e) => {
          setActivoEventosAction(dispatch, event.evento);
          if (isDetalles) {
            setOpenModalDetalles(true);
            return;
          }
          setOpenModalForm(true);
        }}
      />

      <ModalComponent
        id="modalDetalleEvento"
        title="Detalles del evento"
        open={openModalDetalles}
        maxWidth="lg"
        onClose={() => setOpenModalDetalles(!openModalDetalles)}
      >
        <DetallesEventosComponent />
      </ModalComponent>
    </Paper>
  );
};

export default CalendarioEventosComponent;
